/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CollectionItem } from './CollectionItem';
import {
    CollectionItemFromJSON,
    CollectionItemFromJSONTyped,
    CollectionItemToJSON,
    CollectionItemToJSONTyped,
} from './CollectionItem';

/**
 * 
 * @export
 * @interface CollectResponse
 */
export interface CollectResponse {
    /**
     * 
     * @type {CollectionItem}
     * @memberof CollectResponse
     */
    item: CollectionItem;
    /**
     * 
     * @type {boolean}
     * @memberof CollectResponse
     */
    isDuplicate: boolean;
    /**
     * 
     * @type {number}
     * @memberof CollectResponse
     */
    totalUnique: number;
    /**
     * 
     * @type {number}
     * @memberof CollectResponse
     */
    completionThreshold: number;
    /**
     * 
     * @type {boolean}
     * @memberof CollectResponse
     */
    completed: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CollectResponse
     */
    collectedItemIds: Array<string>;
}

/**
 * Check if a given object implements the CollectResponse interface.
 */
export function instanceOfCollectResponse(value: object): value is CollectResponse {
    if (!('item' in value) || value['item'] === undefined) return false;
    if (!('isDuplicate' in value) || value['isDuplicate'] === undefined) return false;
    if (!('totalUnique' in value) || value['totalUnique'] === undefined) return false;
    if (!('completionThreshold' in value) || value['completionThreshold'] === undefined) return false;
    if (!('completed' in value) || value['completed'] === undefined) return false;
    if (!('collectedItemIds' in value) || value['collectedItemIds'] === undefined) return false;
    return true;
}

export function CollectResponseFromJSON(json: any): CollectResponse {
    return CollectResponseFromJSONTyped(json, false);
}

export function CollectResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CollectResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'item': CollectionItemFromJSON(json['item']),
        'isDuplicate': json['isDuplicate'],
        'totalUnique': json['totalUnique'],
        'completionThreshold': json['completionThreshold'],
        'completed': json['completed'],
        'collectedItemIds': json['collectedItemIds'],
    };
}

export function CollectResponseToJSON(json: any): CollectResponse {
    return CollectResponseToJSONTyped(json, false);
}

export function CollectResponseToJSONTyped(value?: CollectResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'item': CollectionItemToJSON(value['item']),
        'isDuplicate': value['isDuplicate'],
        'totalUnique': value['totalUnique'],
        'completionThreshold': value['completionThreshold'],
        'completed': value['completed'],
        'collectedItemIds': value['collectedItemIds'],
    };
}

